import {
  HttpRequestGet,
  HttpRequestPost,
  HttpRegularPost,
  HttpRegularPut,
} from "./../../service/index";
import { IPromotionCode } from "../reducers/promotionCodes";
import PromotionCodes from "../symbols/promotionCodes";

const promotionCodesSymbolsAction = () => {
  return {
    type: PromotionCodes.GET_PROMOTION_CODES,
  };
};

const promotionCodesClearSymbolsAction = () => {
  return {
    type: PromotionCodes.CLEAR_PROMOTION_CODES,
  };
};

type GetPromotionCodesResponseModel = {
  DisplayDate: string;
  PromoCodes: IPromotionCode[];
};
const promotionCodesSymbolsSuccessAction = (
  data: GetPromotionCodesResponseModel[]
) => {
  return {
    type: PromotionCodes.PROMOTION_CODES_SUCCESS,
    payload: data,
  };
};
const promotionCodesSymbolsFailureAction = (data: any) => {
  return {
    type: PromotionCodes.PROMOTION_CODES_FAILURE,
    payload: data,
  };
};

const promotionCodesSymbolsEditSuccessAction = () => {
  return {
    type: PromotionCodes.PROMOTION_CODE_EDIT_CODE_SUCCESS,
  };
};

const promotionCodesSetCurrentAction = (data: IPromotionCode) => {
  return {
    type: PromotionCodes.SET_CURRENT,
    payload: data,
  };
};
const promotionCodesSymbolsGenerateSuccessAction = (data: any) => {
  return {
    type: PromotionCodes.PROMOTION_CODES_GENERATE_SUCCESS,
    payload: data.Result,
  };
};
const promotionCodesSymbolsClearGeneratedAction = () => {
  return {
    type: PromotionCodes.PROMOTION_CODES_GENERATE_SUCCESS,
    payload: "",
  };
};
const promotionCodesSymbolsClearErrorAction = () => {
  return {
    type: PromotionCodes.PROMOTION_CODES_CLEAR_ERROR,
  };
};
const promotionCodesCreateSymbolsAction = () => {
  return {
    type: PromotionCodes.CREATE_PROMOTION_CODES,
  };
};
const promotionCodesSymbolsCreateFailureAction = (errorMessage: string) => {
  return {
    type: PromotionCodes.CREATE_PROMOTION_CODES_FAILURE,
    payload: errorMessage,
  };
};
const promotionCodesCreateSymbolsSuccessAction = () => {
  return {
    type: PromotionCodes.CREATE_PROMOTION_CODE_SUCCESS,
  };
};
export function setCurrentPromotionCode(data: IPromotionCode) {
  return (dispatch: any) => {
    dispatch(promotionCodesSetCurrentAction(data));
  };
}
// /portal/promo-code/list post
export interface IPromotionCodeFilter {
  CodeType: string[];
  DiscountType: string[];
  UseType: string[];
  MinimumSpend?: boolean;
  Status?: boolean;
  UsedBy?: string[];
  Referrer?: string[];
  CustomerIds?: string[];
}
type GetPromotionCodesRequestModel = {
  Page: number;
  Size: number;
  Query: string;
  OrderBy: string;
  Filter: IPromotionCodeFilter;
};

export function clearPromotionCodes() {
  return (dispatch: any) => {
    dispatch(promotionCodesClearSymbolsAction());
  };
}

export function getPromotionCodes(
  data: GetPromotionCodesRequestModel = {
    Page: 1,
    Size: 15,
    Query: "",
    OrderBy: "Expires",
    Filter: {
      DiscountType: [],
      UseType: [],
      CodeType: [],
      CustomerIds: [],
    },
  }
) {
  return (dispatch: any) => {
    dispatch(promotionCodesSymbolsAction());
    HttpRequestPost(
      "/portal/promo-code/list",
      dispatch,
      promotionCodesSymbolsSuccessAction,
      promotionCodesSymbolsFailureAction,
      true,
      data
    );
  };
}

export function getUsedCodes(
  data: GetPromotionCodesRequestModel = {
    Page: 1,
    Size: 15,
    Query: "",
    OrderBy: "Expires",
    Filter: {
      DiscountType: [],
      UseType: [],
      CodeType: [],
      UsedBy: [],
      Referrer: [],
    },
  }
) {
  return (dispatch: any) => {
    dispatch(promotionCodesSymbolsAction());
    HttpRequestPost(
      "/portal/used-codes/list",
      dispatch,
      promotionCodesSymbolsSuccessAction,
      promotionCodesSymbolsFailureAction,
      true,
      data
    );
  };
}

type CreatePromotionCodeRequestModel = {
  Code: string;
  Type: string;
  Amount: number | null;
  Percentage: number | null;
  PromoCode: string;
  Expires: string;
  StartDate: string;
  MinimumSpend: number | null;
};
export const createErrorExceptions = ["Not a valid promo code type."];
export function createPromotionCode(
  data: CreatePromotionCodeRequestModel,
  callback?: () => void
) {
  return (dispatch: any) => {
    dispatch(promotionCodesCreateSymbolsAction());
    HttpRegularPost("/portal/promo-code", data, {
      dispatch: dispatch,
      actionSuccess: getPromotionCodes,
      actionFailure: promotionCodesSymbolsCreateFailureAction,
      callback: () => {
        if (callback) {
          callback();
        }
        dispatch(promotionCodesCreateSymbolsSuccessAction());
      },
    });
  };
}

export function generatePromoCode() {
  return (dispatch: any) => {
    HttpRequestGet(
      "/portal/promo-code/available",
      dispatch,
      promotionCodesSymbolsGenerateSuccessAction,
      promotionCodesSymbolsFailureAction,
      true
    );
  };
}
export function clearGeneratedPromoCode() {
  return (dispatch: any) => {
    dispatch(promotionCodesSymbolsClearGeneratedAction());
  };
}

type EditPromotionCodeRequestModel = {
  Expires: string;
};
export function editPromotionCode(
  guid: string,
  data: EditPromotionCodeRequestModel,
  callback?: () => void
) {
  return (dispatch: any) => {
    dispatch(promotionCodesSymbolsAction());
    HttpRegularPut(`/portal/promo-code/${guid}`, data, {
      dispatch,
      actionSuccess: promotionCodesSymbolsEditSuccessAction,
      actionFailure: promotionCodesSymbolsFailureAction,
      callback: () => {
        if (callback) {
          callback();
        }
        dispatch(promotionCodesCreateSymbolsSuccessAction());
      },
    });
  };
}
export function deactivatePromotionCode(
  guid: string,
  callback?: () => void
) {
  return (dispatch: any) => {
    dispatch(promotionCodesSymbolsAction());
    HttpRegularPut(`/portal/promo-code/${guid}/expire`, {}, {
      dispatch,
      actionSuccess: promotionCodesSymbolsEditSuccessAction,
      actionFailure: promotionCodesSymbolsFailureAction,
      callback: () => {
        if (callback) {
          callback();
        }
        dispatch(promotionCodesCreateSymbolsSuccessAction());
      },
    });
  };
}
export function clearPromotionCodeError() {
  return (dispatch: any) => {
    dispatch(promotionCodesSymbolsClearErrorAction());
  };
}

export interface IPromoCodeNameFilterItem {
  Id: string
  FirstName: string
  LastName: string
  Email: string
  PhoneNumber: string
  Deleted: boolean
}
interface IGetReferralVoucherNamesResponse {
  Result: IPromoCodeNameFilterItem[];
}

export function getReferralVoucherNames(
  success,
  failure
): void {
  HttpRequestGet(
    '/portal/promo-code/referral-voucher-names',
    () => undefined,
    (response: IGetReferralVoucherNamesResponse) => success(response.Result),
    (error: any) => failure(error),
    true
  );
}
interface IGetUsedsByNamesResponseModel {
  Result: IPromoCodeNameFilterItem[];
}

export function getUsedCodesByNames(
  success,
  failure
): void {
  HttpRequestGet(
    '/portal/used-codes/used-by-names',
    () => undefined,
    (response: IGetUsedsByNamesResponseModel) => success(response.Result),
    (error: any) => failure(error),
    true
  );
}

export function getUsedCodesByReferredNames(
  success,
  failure
): void {
  HttpRequestGet(
    '/portal/used-codes/referred-by-names',
    () => undefined,
    (response: IGetUsedsByNamesResponseModel) => success(response.Result),
    (error: any) => failure(error),
    true
  );
}

